// translations/pages/events/bg.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageBG = {
  title: 'Събития',
  upcoming: 'Предстоящи събития',
  past: 'Минали събития',
  all: 'Всички събития',
  items: {
    wikki26: {
      title: 'WiKKI26 – Конференция за изкуствен интелект във Вилдау',
      description: 'pAIoneer Labs участва като изложител в Technische Hochschule Wildau. Темата на щанда беше как се изграждат локални ИИ инфраструктури във фирми и организации: суверенитет на данните, защита на данните на етапа на проектирането и ИИ в съответствие с правните изисквания, без излишна зависимост от външни облачни решения.'
    }
  }
};
